import { render, staticRenderFns } from "./TicketMessage.vue?vue&type=template&id=630590f4&scoped=true&"
import script from "./TicketMessage.vue?vue&type=script&lang=js&"
export * from "./TicketMessage.vue?vue&type=script&lang=js&"
import style0 from "./TicketMessage.vue?vue&type=style&index=0&id=630590f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630590f4",
  null
  
)

export default component.exports